<template>
    <div id="contendor-principal-registroDeEmpresa">
        <div id="contenedor-encabezados-cancelacionDeCedula" class="text-left">
            <h1>EMPRESAS PARA NOTIFICACIÓN</h1>
            <!-- <h3>Ingrese la información requerida para registrar una empresa en el catalogo de empresas </h3> -->
        </div>
        <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
            <div class="flex-grow-1 pl-3"><h4 style="color: white !important;">Administración de Empresas</h4></div>
        </div>
        <div id="contenedor-formulario-registro">
            <div id="formulario-registro" class="area col-12">
                <div id="misEmpresas" class="form-inline justify-content-end">
                    <h6 style="color: black !important;" v-if="verEmpresa || enEdicion || eliminarEmpresa" @click="evtNuevaEmpresa" class="mr-3"><i class="fas fa-plus-square"></i>&nbsp;Nueva Empresa</h6>
                    <h6 style="color: black !important;" @click="evtVerMisEmpresas({ tipoDeVisualizacion: TIPOS_VISUALIZACION_CATALOGO.TABLA })"><i class="fas fa-book"></i>&nbsp;Mis empresas</h6>
                </div>
                <CFormularioRegistroEmpresa v-show="enEdicion || (!enEdicion && !verEmpresa && !eliminarEmpresa)"
                    :idFormulario="ID_FORMULARIO_REGISTRO"
                    :ref="REF_FORMULARIO_REGISTRO"
                    :instrucciones="nombreAccion"
                    :implementarGuardado="false"
                    :empresa="empresaObj"
                    :mostrarErroresEnFormulario="mostrarErrores"                    
                    v-on:obtenerEmpresaObj="empresaObj = $event"
                    v-on:obtenerMostrarErrores="mostrarErrores = $event"
                    v-on:evtActualizarCatalogo="evtActualizarCatalogoEmpresas"
                    :key="'FormRegEmps' + contRenderFormEmpresa"></CFormularioRegistroEmpresa>
                <div v-show="eliminarEmpresa || verEmpresa || eliminarEmpresa" class="mt-3">
                    <h5><i class="fas fa-info-circle"></i> Consulta la información. </h5>
                    <div class="form-group contenedor-color-negro mt-3">
                        <div class="form-inline col-6 pl-0 mt-3"> 
                            <h6>Notificador asignado:</h6>
                            <input disabled="disabled" v-model="notificadorAsignadoNombre" type="text" id="texto_notificador_asignado" class="ml-2 text-center form-control flex-grow-1"/>
                        </div>
                        <div class="d-flex mt-4">
                            <div class="form-group col-6 col-6-sm pl-0">
                                <h6>Domicilios</h6>
                                <TablaGenericaCedulas class="table-responsive"
                                    :idDelInput="'TablaDomicilios_VRDE'" 
                                    :encabezadosColumnas="['#','Domicilio']" 
                                    :accionesEnTabla="{ motrarAcciones: false }" 
                                    :listaDeCedulas="i_domicilios"
                                    :ref="REF_T_DOMICILIOS"></TablaGenericaCedulas>
                            </div>
                            <div class="form-group col-6 col-6-sm pr-0">
                                <h6>Representantes Legales</h6>
                                <TablaGenericaCedulas class="table-responsive"
                                    :idDelInput="'TablaRepresentantes_VRDE'" 
                                    :encabezadosColumnas="['#', 'Nombre de representante']" 
                                    :accionesEnTabla="{ motrarAcciones: false }" 
                                    :listaDeCedulas="i_representantesLegales"
                                    :ref="REF_T_REPRESENTANTES"></TablaGenericaCedulas>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <div style="margin-top: 2em;">
                        <button v-if="!enEdicion && !verEmpresa && !eliminarEmpresa" type="button" @click="evtGuardarEmpresa" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar Empresa</button>
                        <button v-if="enEdicion && !verEmpresa && !eliminarEmpresa" type="button" @click="evtGuardarCambiosEmpresa" class="btn btn-primary"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar cambios</button>
                        <button v-if="!enEdicion && !verEmpresa && eliminarEmpresa" type="button" @click="evtEliminarEmpresaCatalogo" class="btn btn-primary"><i class="fas fa-minus-square"></i>&nbsp;&nbsp;Eliminar del catálogo</button>
                    </div> 
                </div>
            </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="mis-empresas-vrde">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Catálogo de empresas</h5>
                    <button id="btn-cerrar-mis-empresas-vrde" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                </div>
                <div class="modal-body">
                    <div id="contenedor-error-formulario" v-if="mostrarErroresAdmin && !this.campoRequeridoEsValido(empresaSeleccionada)">
                        <h6><i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Error en formulario</h6>
                        <span style="text-align: justify; display:block;">No se encuentra ninguna empresa seleccionada</span>
                    </div>
                    <div class="contenedor-color-negro">
                        <h6>Selecciona la empresa y realiza alguna de las acciones</h6>
                        <hr style="height:1px;border:none;color:var(--verde-pj-100);background-color:var(--verde-pj-100);" class="mt-0"/>
                        <C007Empresas class="p-0 m-0" v-on:valorParaElPadre="cambioDeEmpresa" 
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="'TiposDeEmpresas'" 
                            :parametros="{EmpresaId: null, Nombre: null, ConInactivas: false, ConDomicilios: true, ConRepresentantesLegales: true, ConNotificador: true }" 
                            :valorDefinido="-1" 
                            :key="'CEmpresasK' + contRendCEmpresas"></C007Empresas>
                    </div>
                    <div id="administracion-acciones" class="form-inline justify-content-end mt-4">
                        <div class="form-group mr-2">
                            <button type="button" @click="evtVerEmpresa" class="btn btn-primary"><i class="fas fa-eye"></i>&nbsp;Ver</button>
                        </div>
                        <div class="form-group mr-2">
                            <button type="button" @click="evtEditarEmpresa" class="btn btn-primary"><i class="fas fa-edit"></i>&nbsp;Editar</button>
                        </div>
                        <div class="form-group">
                            <button type="button" @click="evtEliminarEmpresa" class="btn btn-primary"><i class="fas fa-minus-square"></i>&nbsp;Eliminar</button>
                        </div>
                    </div>
                </div>  
                </div>
            </div>
        </div>
        <!-- MODAL VERSION TABLA DE EMPRESAS -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-empresas-tabla-vrde">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Catálogo de empresas</h5>
                        <button id="btn-cerrar-modal-empresas-tabla-vrde" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pt-2 pr-4 pb-2 pl-4">
                        <!-- ACCIONES -->
                        <div class="mt-3">
                            <div class="d-flex justify-content-between">
                                <div class="form-inline">
                                    <button type="button" @click="actualizarTablaEmpresas" class="btn btn-sm btn-light">
                                        <i class="fas fa-sync-alt"></i>{{ this.campoRequeridoEsValido(TABLA_EMPRESAS.seleccionadas) ? '' : '&nbsp;&nbsp;Actualizar tabla' }}
                                    </button>
                                    <button v-if="this.campoRequeridoEsValido(TABLA_EMPRESAS.seleccionadas)" @click="iniciarProcesoCambioEstatusAEmpresas" type="button" class="btn btn-sm btn-danger ml-2 mr-2">
                                        <i class="fas fa-minus-square"></i>&nbsp;&nbsp;Remover empresas&nbsp;&nbsp;[ <strong>{{ TABLA_EMPRESAS.seleccionadas.length }}</strong> ]
                                    </button>
                                </div>
                                <!-- ASIGNACION -->
                                <div v-if="this.campoRequeridoEsValido(TABLA_EMPRESAS.seleccionadas)" class="form-inline">
                                    <h6 class="mr-3">Asignar a:</h6>
                                    <C020Notificadores v-if="catalogoNotificadores.lista != null && catalogoNotificadores.lista.length > 0"
                                        class="p-0 m-0" 
                                        v-on:valorParaElPadre="evtCambioNotificador" 
                                        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                        :idDelInput="catalogoNotificadores.ID" 
                                        :listaDeNotificadores="catalogoNotificadores.lista"
                                        :parametros="{}" 
                                        :valorDefinido="catalogoNotificadores.valorDefinido" 
                                        :key="catalogoNotificadores.KEY + catalogoNotificadores.contRender"
                                        :filtrarPorJurisdiccion="true"></C020Notificadores>
                                    <button type="button" @click="iniciarProcesoAsignacionDeNotificador" class="btn btn-sm btn-light ml-2"><i class="fas fa-save"></i></button>
                                </div>
                            </div>
                            <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(39, 39, 39); margin-top:1em; margin-bottom:1em;"/>
                        </div>
                        <!-- TABLA ASIGNACIONES -->
                        <div class="contenedor-tabla-empresas-SINOJ table-responsive" >
                            <table
                                class="table table-light table-hover"
                                :id="TABLA_EMPRESAS.ID"              
                                data-toggle="table"
                                data-pagination="true"
                                data-undefined-text="Sin información"
                                data-maintain-selected="true"  
                                data-page-size = "5"
                                data-page-list="[3,5,10,20]"
                                data-click-to-select="false"
                                data-show-toggle="false"
                                data-show-pagination-switch="true"
                                data-search="true">
                                <thead class="thead-dark">
                                    <tr>
                                        <th data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                                        <th data-halign="center" data-width="5" data-align="center" data-field="EmpresaId" data-sortable="true">
                                            Folio
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="Nombre" data-sortable="true">
                                            Nombre
                                        </th>
                                        <th data-halign="center" data-width="10" data-align="center" data-field="NotificadorSTR" data-sortable="true">
                                            Notificador asignado
                                        </th>
                                        <th data-events="operateEvents" data-width="5" :data-formatter="this.obtenerHTMLAcciones()" data-halign="center" data-align="center">
                                            
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        <!-- FIN MODAL VERSION TABLA DE EMPRESAS -->
    </div>
</template>
<script>
import sistemas from '@/../static/js/sistemas'
import enumeraciones from '@/../static/js/enumeraciones'
import catalogos from '@/../static/js/catalogos'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'

export default {
    components: {
        CFormularioRegistroEmpresa: sistemas.SINOJ.CFormularioRegistroEmpresa,
        C007Empresas: catalogos.SINOJ.C007Empresas,
        TablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas,
        C020Notificadores: catalogos.SINOJ.C020Notificadores,
    },    
    data() {
        return {
            enumeraciones,
            ID_FORMULARIO_REGISTRO: 'formularioDeRegistroAdministracion',
            empresaObj: null,
            mostrarErrores: false,
            REF_FORMULARIO_REGISTRO: 'formRegistroAltaEmpresaCatalogo',
            contRenderFormEmpresa: 0,
            empresaSeleccionada: null,
            mostrarErroresAdmin: false,
            tipoEmpresaId: -1,
            contRendCEmpresas: 0,
            enEdicion: false,
            verEmpresa: false,
            eliminarEmpresa: false,
            i_nombreEmpresa: null,
            i_domicilios: [],
            i_representantesLegales:[],
            REF_T_REPRESENTANTES: 'RefTablaRepresentantesVRDE',
            REF_T_DOMICILIOS: 'RefTablaDomiciliosVRDE',
            nombreAccion: '<i class="fas fa-info-circle"></i> Ingrese los datos para el registro de la empresa o institución en el catálogo',
            nombreNotificador: 'Sin notificador asignado.',
            TIPOS_VISUALIZACION_CATALOGO: {
                TABLA: 1,
                SELECT: 2
            },
            TABLA_EMPRESAS: {
                ID: 'Tabla-Empresas-VRDE',
                listaParaTabla: [],
                listaOriginal: [],
                seleccionadas: [],
                seleccionada: null
            },
            catalogoNotificadores: {
                ID: 'C-TNotificadores-VRDE-SINOJ',
                KEY: 'K-TNotificadores-VRDE-SINOJ',
                contRender: 0,
                lista: [],
                valorDefinido: -1,
                seleccionado: null
            }
        }
    },
    methods: {
        iniciarProcesoCambioEstatusAEmpresas: async function() {
            const PETICION_API = { Empresas: this.TABLA_EMPRESAS.seleccionadas, EsPrueba: false };
            const { conError, mensaje } = await Promise.resolve(this.cambiarEstatusDeEmpresasBD({ peticion: PETICION_API }));
            if(!conError) {
                // se actualizan las listas en memoria
                this.TABLA_EMPRESAS.listaOriginal = this.TABLA_EMPRESAS.listaOriginal
                    .filter(eDB => !this.TABLA_EMPRESAS.seleccionadas.some(eS => eS.EmpresaId == eDB.EmpresaId));

                // se limpian las variables de seleccion
                this.$nextTick(() => {
                    $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('uncheckAll');
                    this.TABLA_EMPRESAS.seleccionadas = [];
                    this.TABLA_EMPRESAS.seleccionada = null;
                });
                this.TABLA_EMPRESAS.listaParaTabla  = await Promise.resolve(this.formatearEmpresasParaTabla({ empresas: this.TABLA_EMPRESAS.listaOriginal }));
                await Promise.resolve(this.inicializarTabla({ elementos: this.TABLA_EMPRESAS.listaParaTabla }));
            }
            comun.mensajeDeAlerta(mensaje);
        },
        cambiarEstatusDeEmpresasBD: async function({ peticion }) { 
          let informacionProceso = { conError: true, mensaje: null };
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_MODIFICAR = api.SINOJ.sistema.administracion.empresas.CambiarEstatusDeEmpresas;
            const URL_SERVICIO_REST = SERVIDOR + METODO_API_MODIFICAR;
            const HEADER_PARA_ENVIO_ARCHIVOS = false;
            const HEADER_PARA_ARRAY_BUFFER = false;
            const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticion, HEADER_SERVICIO_REST);
            const DATOS_RESPUESTA = await RESPUESTA.data;
            let { Satisfactorio, SiHayError, Error } = DATOS_RESPUESTA;
            if (SiHayError) {
                const MENSAJE_ERROR = Error.Mensaje;
                console.error(Error);
                comun.SeEstaCargandoInformacion(false);
                informacionProceso.mensaje = MENSAJE_ERROR;
                //.mensajeDeAlerta(MENSAJE_ERROR);
            } 
            else { 
                informacionProceso.conError = false;
                informacionProceso.mensaje = Satisfactorio;
                //comun.mensajeDeAlerta(Satisfactorio);
            }
            comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
          return informacionProceso;
        },
        iniciarProcesoAsignacionDeNotificador: async function() {
            // se crea la ueva asignacion a los objetos de la empresa
            let empresasConNuevaAsignacion = this.TABLA_EMPRESAS.seleccionadas.map(eS => { 
                let empresaObj = { ...eS};
                if(this.campoRequeridoEsValido(empresaObj.Notificador))
                    empresaObj.Notificador.NotificadorId = this.catalogoNotificadores.valorDefinido;
                else
                    empresaObj.Notificador = { NotificadorId: this.catalogoNotificadores.valorDefinido }
                return empresaObj;
            });

            const PETICION_API = { Empresas: empresasConNuevaAsignacion, EsPrueba: false };
            await Promise.resolve(this.guardarAsignacionesDeNotificadorBD({ peticion: PETICION_API }));

            // se limpian las variables de selccion y catalogos
            this.$nextTick(() => {
                $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('uncheckAll');
                this.TABLA_EMPRESAS.seleccionadas = [];
                this.TABLA_EMPRESAS.seleccionada = null;

                this.catalogoNotificadores.valorDefinido = -1;
                this.catalogoNotificadores.contRender ++;
            });
        },
        guardarAsignacionesDeNotificadorBD: async function({ peticion }) { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_MODIFICAR = api.SINOJ.sistema.administracion.empresas.GuardarAsignacionesANotificador;
            const URL_SERVICIO_REST = SERVIDOR + METODO_API_MODIFICAR;
            const HEADER_PARA_ENVIO_ARCHIVOS = false;
            const HEADER_PARA_ARRAY_BUFFER = false;
            const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticion, HEADER_SERVICIO_REST);
            const DATOS_RESPUESTA = await RESPUESTA.data;
            let { Satisfactorio, SiHayError, Error, Empresas } = DATOS_RESPUESTA;
            if (SiHayError) {
                const MENSAJE_ERROR = Error.Mensaje;
                console.error(Error);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(MENSAJE_ERROR);
            } 
            else { 
                if(this.campoRequeridoEsValido(Empresas)) {
                    await Promise.resolve(this.actualizarFilasEnTablaEmpresas({ filasParaActualizar: Empresas }));
                    comun.mensajeDeAlerta(Satisfactorio);
                }
            }
            comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        },
        actualizarFilasEnTablaEmpresas: async function({ filasParaActualizar, desdeEdicion = false }) {
            let filasConFormato = await Promise.resolve(this.formatearEmpresasParaTabla({ empresas: filasParaActualizar }));

            // se actualizan las nuevas asignaciones a las cedulas en las listas de datos
            filasParaActualizar.forEach(f => {
                let INDEX_FILA_EN_LISTA = this.TABLA_EMPRESAS.listaOriginal.findIndex(eDB => eDB.EmpresaId == f.EmpresaId);
                if(INDEX_FILA_EN_LISTA >= 0) {
                    this.TABLA_EMPRESAS.listaOriginal[INDEX_FILA_EN_LISTA] = f;
                }
            });

            this.$nextTick(() => { 
                filasConFormato.forEach(fila => {   
                    let INDEX_FILA_EN_LISTA = this.TABLA_EMPRESAS.listaParaTabla.findIndex(eT => eT.EmpresaId == fila.EmpresaId);
                    if(INDEX_FILA_EN_LISTA >= 0) {
                        this.TABLA_EMPRESAS.listaParaTabla[INDEX_FILA_EN_LISTA] = fila;
                    }

                    $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('updateByUniqueId', {
                        id: fila.EmpresaId,
                        row: fila
                    });
                });
            });

            if(desdeEdicion) {
                this.evtNuevaEmpresa();
                $('#modal-empresas-tabla-vrde').modal('show');
            }
        },
        evtCambioNotificador: function(evento) {
            this.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
        },
        actualizarTablaEmpresas: async function() {
            $('#modal-empresas-tabla-vrde').modal('hide');
            this.$nextTick(() => {
                $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('uncheckAll');
                this.TABLA_EMPRESAS.seleccionadas = [];
                this.TABLA_EMPRESAS.seleccionada = null;

                this.catalogoNotificadores.valorDefinido = -1;
                this.catalogoNotificadores.contRender ++;
            });

            const PETICION_API = { EmpresaId: null, Nombre: null, ConInactivas: false, ConDomicilios: true, ConRepresentantesLegales: true, ConNotificador: true, EsPrueba: false };
            await Promise.resolve(this.obtenerEmpresasDB({ peticion: PETICION_API }));
            $('#modal-empresas-tabla-vrde').modal('show');
        },
        obtenerEmpresasDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.catalogos.C007TiposEmpresas;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Empresas } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.error(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else { 
                    this.TABLA_EMPRESAS.listaOriginal = (this.campoRequeridoEsValido(Empresas)) ? Empresas : [];
                    console.info('empresasBD::',this.TABLA_EMPRESAS.listaOriginal);
                    this.TABLA_EMPRESAS.listaParaTabla  = await Promise.resolve(this.formatearEmpresasParaTabla({ empresas: Empresas }));
                    await Promise.resolve(this.inicializarTabla({ elementos: this.TABLA_EMPRESAS.listaParaTabla }));
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        formatearEmpresasParaTabla: async function({ empresas }) {
            let empresasFormatoParaTabla = [];
            if(this.campoRequeridoEsValido(empresas)) {
                empresasFormatoParaTabla = empresas.map((e) => {
                    let empresaObj = { ...e };
                    empresaObj.NotificadorSTR = (this.campoRequeridoEsValido(e.Notificador)) ? this.obtenerNombreCompleto(e.Notificador) : 'Sin notificador asignado';
                    return empresaObj;
                });
            }
            return empresasFormatoParaTabla;
        },
        inicializarTabla: async function({ elementos }) { 
            console.info('inicializarTabla::',elementos)
            this.$nextTick(() => {
                $("#" + this.TABLA_EMPRESAS.ID).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table click-row.bs.table");
                $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable({  data: elementos });      
                $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('load', elementos ); 
                // eventos
                $("#" + this.TABLA_EMPRESAS.ID).on('check.bs.table',(e, row) => {
                    this.evtEmpresaSeleccionada({ agregar: true, empresa: row });
                });
                $("#" + this.TABLA_EMPRESAS.ID).on('uncheck.bs.table',(e, row) => {
                    this.evtEmpresaSeleccionada({ agregar: false, empresa: row });
                });
                /* $("#" + this.TABLA_EMPRESAS.ID).on('check-all.bs.table',(e, rows) => {
                    
                });
                $("#" + this.TABLA_EMPRESAS.ID).on('uncheck-all.bs.table',(e, rowsAfter, rowsBefore) => {
                    
                }); */
            });
        },
        evtEmpresaSeleccionada: function({ agregar, empresa }) { 
            const EMPRESA_SELECCIONADA = this.TABLA_EMPRESAS.listaOriginal.find(eDB => eDB.EmpresaId == empresa.EmpresaId);
            if(agregar) {
                if(this.campoRequeridoEsValido(EMPRESA_SELECCIONADA)) {
                    const EMPRESA_AGREGADA_PREVIAMENTE = this.TABLA_EMPRESAS.seleccionadas.some(eS => eS.EmpresaId == EMPRESA_SELECCIONADA.EmpresaId);
                    if(!EMPRESA_AGREGADA_PREVIAMENTE)
                        this.TABLA_EMPRESAS.seleccionadas.push(EMPRESA_SELECCIONADA);
                }
            }
            else {
                this.TABLA_EMPRESAS.seleccionadas = this.TABLA_EMPRESAS.seleccionadas.filter(eS => eS.EmpresaId != EMPRESA_SELECCIONADA.EmpresaId);
            }
        },
        obtenerHTMLAcciones: () => {
            return [
                '<div>',
                    '<button id="btn-editar-empresa-SINOJ-VRDE" title="Editar empresa" type="button" class="btn-acciones-tabla-empresas-VRDE btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-edit"></i></button>',
                    /* '<button id="btn-editarNotificador-empresa-SINOJ-VRDE" title="Editar NOTIFICADOR ASIGNADO" type="button" class="btn-acciones-tabla-empresas-VRDE btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-user-edit"></i></button>', */
                '</div>'
            ].join("");
        },
        evtActualizarCatalogoEmpresas: function(EmpresaObj) {
            //this.contRendCEmpresas ++;
            if(this.campoRequeridoEsValido(EmpresaObj)) {
                this.$nextTick(() => {
                    this.TABLA_EMPRESAS.listaOriginal.push(EmpresaObj);
                    let empresaObj = { ...EmpresaObj}
                    empresaObj.NotificadorSTR = (this.campoRequeridoEsValido(EmpresaObj.Notificador)) ? this.obtenerNombreCompleto(EmpresaObj.Notificador) : 'Sin notificador asignado';
                    $("#" + this.TABLA_EMPRESAS.ID).bootstrapTable('insertRow', {
                        index: 0, 
                        row: empresaObj
                    });
                });
            }
        },
         /**
         * funcion encargado de limpiar los valores. 
         * @param {object} notificador [asignacion que que se removera]
         * @see {@link eliminarNoticadorBD}
         */
        limpiarValoresInformativos: function() {
            this.i_nombreEmpresa = null;
            this.i_domicilios = [];
            this.i_representantesLegales = [];
            this.nombreNotificador = 'Sin notificador asignado';
        },
        asignarValoresInformativos: function() { 
            let contDomicilios = 1;
            let contRepresentantes = 1; 
            this.i_nombreEmpresa = this.empresaSeleccionada.Nombre;
            this.i_domicilios = this.empresaSeleccionada.Domicilios.map(d => {
                let infAdicionalNumExt = (this.campoRequeridoEsValido(d.InformacionAdicionalDeNumeroExterior)) ? ` ${ d.InformacionAdicionalDeNumeroExterior }` : '';
                let numInterior = (this.campoRequeridoEsValido(d.NumeroInterior)) ? `int ${ d.NumeroInterior.toString().trim() }` : '';
                let objDomiciloTabla = {
                    Folio: contDomicilios,
                    /* domicilio: `${d.Calle} ${d.NumeroExterior}${ infAdicionalNumExt } ${ numInterior },${d.Fraccionamiento.Nombre}, ${d.Fraccionamiento.Municipio.Nombre}, ${d.Fraccionamiento.CodigoPostal}, MEX` */
                    domicilio: this.construirDomicilioInformativo({ domicilioObj: d })
                }
                contDomicilios ++;
                return objDomiciloTabla;
            });
            this.i_representantesLegales = this.empresaSeleccionada.RepresentantesLegales.map(r => {
                const DATOS_NOMBRE = [r.DatosGenerales.Fisica.Nombre, r.DatosGenerales.Fisica.ApellidoPaterno, r.DatosGenerales.Fisica.ApellidoMaterno]
                const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
                let objRepresentanteTabla = {
                    Folio: contRepresentantes,
                    Representante: NOMBRE_COMPLETO
                }
                contRepresentantes ++;
                return objRepresentanteTabla;
            });
        },
        construirDomicilioInformativo: function({ domicilioObj }) {
            let domicilioCompleto = 'Sin domicilio';
            const DOMICILIO_OBJ = domicilioObj;
            let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
            let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
            if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                domicilioCompleto = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
            }
            else {
                /* 
                    para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                    con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                    logica.
                    */
                this.domicilioConFraccionamientoFueraDeCatalogo = true;
                let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                let nombreFraccionamiento = fraccionamientoCompuesto[0];
                let nombreMunicipio = fraccionamientoCompuesto[1];
                domicilioCompleto = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
            }
            return domicilioCompleto;
        },
        evtNuevaEmpresa: function() {
            this.enEdicion = false;
            this.verEmpresa = false;
            this.eliminarEmpresa = false;
            this.empresaObj = null;
            this.nombreAccion = '<i class="fas fa-info-circle" style="color: black;"></i> Ingrese los datos para el registro de la empresa o institución en el catalogo'
            this.contRenderFormEmpresa ++;
            this.contRendCEmpresas ++;
            this.empresaSeleccionada = null;
            this.tipoEmpresaId = -1;
            this.mostrarErroresAdmin = false;
        },
        evtEditarEmpresa: function() { //debugger
            if(this.campoRequeridoEsValido(this.empresaSeleccionada)) {
                //console.log('empresaSeleccionaeditar::',this.empresaSeleccionada)
                $('#mis-empresas-vrde').modal('hide');
                this.empresaObj = this.empresaSeleccionada;
                this.nombreAccion = '<i class="fas fa-info-circle"></i> Realiza las modificaiones necesarias y guarda los cambios'
                this.mostrarErrores = false;
                this.contRenderFormEmpresa ++;
                this.$refs[this.REF_FORMULARIO_REGISTRO].tipoNotificadorId = (this.campoRequeridoEsValido(this.empresaSeleccionada.Notificador)) ? this.empresaSeleccionada.Notificador.NotificadorId : -1;
                this.enEdicion = true;
                this.verEmpresa = false;
                this.eliminarEmpresa = false;
            }
            else {
                this.mostrarErroresAdmin = true;
            }
        },
        evtVerEmpresa: function() {
            if(this.campoRequeridoEsValido(this.empresaSeleccionada)) {
                $('#mis-empresas-vrde').modal('hide');
                /* this.empresaObj = this.empresaSeleccionada; */
                let { Notificador } = this.empresaSeleccionada;
                this.mostrarErrores = false;
                this.contRenderFormEmpresa ++;
                this.enEdicion = false;
                this.verEmpresa = true;
                this.eliminarEmpresa = false;
                this.limpiarValoresInformativos();
                this.asignarValoresInformativos();
                this.nombreNotificador = (this.campoRequeridoEsValido(Notificador)) ? this.obtenerNombreCompleto(Notificador) : 'Sin notificador asignado';
            }
            else {
                this.mostrarErroresAdmin = true;
            }
        },
        evtGuardarCambiosEmpresa: function() { 
            if(this.$refs[this.REF_FORMULARIO_REGISTRO].empresaEstaCompleta()){
                this.empresaObj.EmpresaId = this.empresaSeleccionada.EmpresaId;
                this.empresaObj.Notificador = (this.campoRequeridoEsValido(this.$refs[this.REF_FORMULARIO_REGISTRO].tipoNotificadorId)) 
                    ? { NotificadorId: this.$refs[this.REF_FORMULARIO_REGISTRO].tipoNotificadorId } 
                    : null;
                let peticionAPI = {
                    Empresa: this.empresaObj,
                    EsPrueba: false
                }
                //console.log('objetoEmpresa::',this.empresaObj);
                //console.log('peticion::',peticionAPI);
                this.guardarCambiosDeEmpresaBD(peticionAPI);
            }
            else {
                this.$refs[this.REF_FORMULARIO_REGISTRO].mostrar_errores = true;
                comun.mensajeDeAlerta('se detectaron campos incorrectos', null, null);
            }
        },
        guardarCambiosDeEmpresaBD: function(peticionAPI) {
            const SERVIDOR = api.conexion;
            const METODO_API_GUARDAR = api.SINOJ.sistema.administracion.empresas.GuardarNuevaEmpresa;
            let urlApi = SERVIDOR + METODO_API_GUARDAR;
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        comun.SeEstaCargandoInformacion(false);
                        this.$refs[this.REF_FORMULARIO_REGISTRO].mostrar_errores = false;
                        this.contRendCEmpresas ++;
                        this.actualizarFilasEnTablaEmpresas({ filasParaActualizar: [ respuesta.data.Empresa ], desdeEdicion: true });
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
            ); 
        },
        evtEliminarEmpresa: function() {
            if(this.campoRequeridoEsValido(this.empresaSeleccionada)) {
                $('#mis-empresas-vrde').modal('hide');
                /* this.empresaObj = this.empresaSeleccionada;
                this.nombreAccion = '<i class="fas fa-info-circle"></i> Consulta la informacion antes de eliminar la empresa.' */
                let { Notificador } = this.empresaSeleccionada;
                this.mostrarErrores = false;
                this.contRenderFormEmpresa ++;
                this.enEdicion = false;
                this.verEmpresa = false;
                this.eliminarEmpresa = true;
                this.limpiarValoresInformativos();
                this.asignarValoresInformativos();
                this.nombreNotificador = (this.campoRequeridoEsValido(Notificador)) ? this.obtenerNombreCompleto(Notificador) : 'Sin notificador asignado';
            }
            else {
                this.mostrarErroresAdmin = true;
            }
        },
        evtEliminarEmpresaCatalogo: function() {
            if(this.campoRequeridoEsValido(this.empresaSeleccionada)) {
                this.informarConfirmacionDeEliminar();
            }
            else {
                comun.mensajeDeAlerta('No hay ninguna empresa seleccionada');
            }
        },
        eliminarEmpresaBD: function() {
            const SERVIDOR = api.conexion;
            const METODO_API_ELIMINAR = api.SINOJ.sistema.administracion.empresas.EliminarEmpresa;
            let urlApi = SERVIDOR + METODO_API_ELIMINAR;
            let peticionArchivos = false;
            let peticionAPI = {
                Empresa: { EmpresaId: this.empresaSeleccionada.EmpresaId },
                esPrueba: false
            };
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        comun.SeEstaCargandoInformacion(false);
                        this.mostrarErrores = false;
                        this.contRenderFormEmpresa ++;
                        this.contRendCEmpresas ++;
                        this.empresaSeleccionada = null;
                        this.tipoEmpresaId = -1;
                        this.mostrarErroresAdmin = false;
                        this.enEdicion = false;
                        this.verEmpresa = false;
                        this.eliminarEmpresa = false;
                        this.limpiarValoresInformativos();
                        this.empresaObj = null;
                        this.empresaSeleccionada = null;
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
            ); 
        },
        evtVerMisEmpresas: function({ tipoDeVisualizacion }) {
            const ID_MODAL = (tipoDeVisualizacion = this.TIPOS_VISUALIZACION_CATALOGO.TABLA) ? '#modal-empresas-tabla-vrde' : '#mis-empresas-vrde';
            $(ID_MODAL).modal('show'); 
            /* this.contRendCEmpresas ++;
            this.empresaSeleccionada = null;
            this.tipoEmpresaId = -1;
            this.mostrarErroresAdmin = false; */
        },
        cambioDeEmpresa: function(evento,empresaObj) {
            //console.log('cambioDeEmpresa::',empresaObj);
            this.tipoEmpresaId = parseInt(evento.target.value);
            if(this.campoRequeridoEsValido(this.tipoEmpresaId)) {
                 this.empresaSeleccionada = empresaObj;
                 this.mostrarErroresAdmin = false;
            }
            else
                this.empresaSeleccionada = null;
            //this.contRenderFormEmpresa ++;
        },
        obtEmps: function() {
            //console.log('emp::completa::',this.empresaObj);
        },
        evtGuardarEmpresa:  function() {
           this.$refs[this.REF_FORMULARIO_REGISTRO].evtGuardarEmpresa();
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        informarConfirmacionDeEliminar: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas eliminar la empres '${this.empresaSeleccionada.Nombre}' del catalogo<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.eliminarEmpresaBD();
                    }
                }
            });
        },
        obtenerNombreCompleto: function(notificador) {
            let nombres = [notificador.Usuario.Nombre, notificador.Usuario.ApellidoPaterno, notificador.Usuario.ApellidoMaterno]
            const NOMBRE_COMPLETO = nombres.join(' ');
            return NOMBRE_COMPLETO;
        },
        obtenerCatalogoDeNotificadoresBD: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.catalogos.C020TiposNotificadores;
            const URL_SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false };
            peticionAPI.EsPrueba = false;
            peticionAPI.ConAreaDeUsuario = true;
            const HEADER_PARA_ENVIO_ARCHIVOS = false;
            const HEADER_PARA_ARRAY_BUFFER = false;
            const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticionAPI, HEADER_SERVICIO_REST);
            const DATOS_RESPUESTA = await RESPUESTA.data;
            let { SiHayError, Error, Notificadores } = DATOS_RESPUESTA;
            if (SiHayError) {
                const MENSAJE_ERROR = Error.Mensaje;
                console.error(Error);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(MENSAJE_ERROR);
            } 
            else { 
                this.catalogoNotificadores.lista = Notificadores;
            }
            comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        },
        editarEmpresaTabla: function({ empresa }) { debugger
            $('#modal-empresas-tabla-vrde').modal('hide');
            this.empresaObj = this.TABLA_EMPRESAS.listaOriginal.find(eDB => eDB.EmpresaId == empresa.EmpresaId);
            this.empresaSeleccionada = this.empresaObj;
            this.nombreAccion = '<i class="fas fa-info-circle"></i> Realiza las modificaiones necesarias y guarda los cambios'
            this.mostrarErrores = false;
            this.contRenderFormEmpresa ++;
            this.$nextTick(() => {
                this.$refs[this.REF_FORMULARIO_REGISTRO].tipoNotificadorId = (this.campoRequeridoEsValido(this.empresaObj.Notificador)) ? this.empresaObj.Notificador.NotificadorId : -1;
            })
            this.enEdicion = true;
            this.verEmpresa = false;
            this.eliminarEmpresa = false;
        }
    },
    computed: {
        notificadorAsignadoNombre() {
            return this.nombreNotificador;
        }
    },
    mounted() {
        window.operateEvents = {
            "click #btn-editar-empresa-SINOJ-VRDE": (e,val,row,index) => {   
                this.editarEmpresaTabla({ empresa:row });
            },
            /* "click #btn-editarNotificador-empresa-SINOJ-VRDE": (e,val,row,index) => {   
                
            }, */
        };
     this.$refs[this.REF_T_DOMICILIOS].cedulasAmostrarPorPagina = 1;
     this.$refs[this.REF_T_REPRESENTANTES].cedulasAmostrarPorPagina = 1;
    },
    async created() {
        const PETICION_API = { EmpresaId: null, Nombre: null, ConInactivas: false, ConDomicilios: true, ConRepresentantesLegales: true, ConNotificador: true, EsPrueba: false };
        await Promise.resolve(this.obtenerEmpresasDB({ peticion: PETICION_API }));
        await Promise.resolve(this.obtenerCatalogoDeNotificadoresBD());
    }
}
</script>
<style scoped>

#contenedor-formulario-registro {
    display: flex;
    justify-content: center
}

#misEmpresas h6:hover, #misEmpresas h6:focus {
    text-decoration-line: underline;
    font-weight: bold;
    cursor: pointer;
}

#mis-empresas-vrde .modal-lg {
    max-width: 45% !important;
}

#mis-empresas-vrde .modal-header {
    background-color: var(--verde-pj);
    border: none;
}

#mis-empresas-vrde .modal-body {
    background-color: var(--gris-pj-100);
}

#modal-empresas-tabla-vrde .modal-lg {
    max-width: 60% !important;
}

#modal-empresas-tabla-vrde .modal-header {
    background-color: var(--verde-pj);
    border: none;
}

#administracion-acciones .btn {
    cursor: pointer;
    padding: 6px 10px 6px 10px;
    background-color: #494747;
}

#administracion-acciones .btn:hover, #administracion-acciones .btn:focus{
    background-color: #000000;
    box-shadow: none;
}

#contenedor-error-formulario {
    padding: 1em;
    background-color: #26272b;
    border: 1px solid #5c5959;
    border-radius: 8px;
    margin-bottom: 1em;;
}

.contenedor-color-negro {
    padding: 1.5em;
    /* background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616; */
}

#encabezado-contenedor-contenido {
  background-color: var(--verde-pj);
  padding: 10px;
}

.modal-body {
    background-color: var(--gris-pj-100);
}
</style>
<style>
.contenedor-tabla-empresas-SINOJ .btn-secondary {
    width: 2.5rem;
    background-color: #1f1f21;
    color: white;
    padding: 0.3em 0.3em 0.3em 0.3em;
    box-shadow: none;
}

.contenedor-tabla-empresas-SINOJ .form-control {
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
    width: 40vmin;
}

.contenedor-tabla-empresas-SINOJ td {
    /* background-color: rgb(238, 238, 238);
    vertical-align: middle; */
    cursor: pointer;
}

.contenedor-tabla-empresas-SINOJ tr.custom--success td {
    background-color: #5e5e5e; /*custom color here add !important if you don't want the hover color*/
    color: white;
}

.contenedor-tabla-empresas-SINOJ table {
    table-layout: fixed;
    width: 100%;
    word-wrap:break-word;
}

.contenedor-tabla-empresas-SINOJ .btn-light {
    background-color: white;
    border: 1px solid #4F4949;
    color: #111111;
    font-size: 1em;
}

.contenedor-tabla-empresas-SINOJ .btn-acciones-tabla-empresas-VRDE:hover, .contenedor-tabla-empresas-SINOJ .btn-acciones-tabla-empresas-VRDE:focus {
    background-color: #1c1d1d;
    border: 1px solid #e1e2e2;
    color: white;
}

.contenedor-tabla-empresas-SINOJ .dropdown-toggle {
    width: 3.3rem;
    background-color: #1f1f21;
    color: white;
}

.contenedor-tabla-empresas-SINOJ .bs-checkbox .th-inner {
    pointer-events:none !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
}

.contenedor-tabla-empresas-SINOJ .pagination > li > a {
    background-color: white;
    color: #121213;
}

.contenedor-tabla-empresas-SINOJ .pagination > .active > a {
    color: white;
    background-color:  #1f1f21;
    border: solid 1px #676666;
}

.contenedor-tabla-empresas-SINOJ > .active > a:hover {
    background-color:  #21211f;
    border: solid 1px #676666;
}

#contendor-principal-registroDeEmpresa .area {
    background-color: var(--gris-pj-100);
}

#contendor-principal-registroDeEmpresa .form-control {
    background-color: white !important;
    color: black !important;
}

 thead th {
        background-color: #004746 !important;
    }

    #contendor-principal-registroDeEmpresa .btn-primary {
        background-color: var(--verde-pj-100);
    }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Administracion/Empresas/CRegistroDeEmpresaNotificacion.vue